import React from "react";
import { Tag, TagRow } from "./style";

export default () => (
  <TagRow>
    <Tag>Software Engineer</Tag>
    <Tag>M.Sc Comp-Sci</Tag>
    <Tag>Married (soon!)</Tag>
    <Tag>Dad</Tag>
    <Tag>Open-Source contributor</Tag>
    <Tag>Friend</Tag>
    <Tag>Stranger</Tag>
  </TagRow>
);
